var _ = require('lodash');

module.exports = function (testimonial) {
    return {
        data : _.wrap({ 
            testimonial : testimonial,
        }),
        props : ['slide', 'index', 'industry', 'baseFontSize'],
        template: require('./testimonial.html'),
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/testimonial/testimonial.js
// module id = 98
// module chunks = 0